import { ChevronDown, ChevronRight } from 'lucide-react'
import type { DataTableColumn } from '@/components/DataTable'
import { RowActions } from '@/components/RowActions'
import { Tag } from '@/components/Tag'
import type { ExtractorEntry } from '@/types/bundle'

export interface ExtractorRow {
  id: string
  extractor: ExtractorEntry
}

export interface ExtractorColumnsOptions {
  expandedId: string | null
  onToggleExpand: (id: string) => void
  onDuplicate: (row: ExtractorRow) => void
  onDelete: (row: ExtractorRow) => void
}

// Collapsed-row cell renderers, passed to DataTable's `columns` - the ID
// cell doubles as the row's expand/collapse toggle, same convention as
// Lookup Table's own getLookupTableColumns.
export function getExtractorColumns({
  expandedId,
  onToggleExpand,
  onDuplicate,
  onDelete,
}: ExtractorColumnsOptions): DataTableColumn<ExtractorRow>[] {
  return [
    {
      key: 'id',
      header: 'Extractor ID',
      render: (row) => {
        const expanded = row.id === expandedId
        return (
          <button
            type="button"
            onClick={() => onToggleExpand(row.id)}
            className="flex items-center gap-2 text-left font-medium text-text-primary"
          >
            {expanded ? (
              <ChevronDown size={16} strokeWidth={1.5} className="text-text-secondary" />
            ) : (
              <ChevronRight size={16} strokeWidth={1.5} className="text-text-secondary" />
            )}
            {row.id}
          </button>
        )
      },
    },
    {
      key: 'model_id',
      header: 'Model',
      render: (row) => row.extractor.model_id || <span className="text-text-disabled">-</span>,
    },
    {
      key: 'enabled',
      header: 'Status',
      render: (row) =>
        row.extractor.enabled ? <Tag label="Enabled" /> : <Tag label="Disabled" variant="danger" />,
    },
    {
      key: 'actions',
      header: '',
      align: 'right',
      render: (row) => (
        <RowActions onDuplicate={() => onDuplicate(row)} onDelete={() => onDelete(row)} />
      ),
    },
  ]
}
